import { createRouter, createWebHistory } from 'vue-router'
import TopComponent from '../components/TopComponent.vue'
import ProfileMenu from '../components/ProfileMenu.vue'
import FilmDetail from '../components/FilmDetail.vue' // 作品紹介ページのコンポーネントをインポート
import InformationComponent from '../components/InformationComponent.vue'
import ContactComponent from '../components/ContactComponent.vue'

const routes = [
  {
    path: '/',
    name: 'top',
    component: TopComponent
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileMenu
  },
  {
    path: '/film/:id', // 動的セグメントを使用して、作品のIDをURLパラメータとして受け取る
    name: 'filmDetail',
    component: FilmDetail
  },
  {
    path: '/information', // INFORMATION
    name: 'information',
    component: InformationComponent
  },
  {
    path: '/contact', // CONTACT
    name: 'contact',
    component: ContactComponent
  }

]

let previousPath = null;

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 遷移元を記録
    previousPath = from.fullPath;
    return savedPosition || { top: 0 };
  }
});

export { previousPath }; // ← 外部から使えるように export
export default router;